module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "form",
    attrs: {
      "action": ""
    }
  }, [(_vm.errorMessage) ? _c('Message', {
    attrs: {
      "message-content": _vm.errorMessage,
      "message-status": "error"
    }
  }) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                  Wall:\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text"
  }, [_c('v-select', {
    attrs: {
      "required": "",
      "searchable": false,
      "placeholder": "Click to select a wall",
      "options": _vm.walls
    },
    model: {
      value: (_vm.wallId),
      callback: function($$v) {
        _vm.wallId = $$v
      },
      expression: "wallId"
    }
  })], 1)]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                  From this day:\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text"
  }, [_c('el-date-picker', {
    attrs: {
      "required": "",
      "type": "date",
      "placeholder": "From this day:"
    },
    model: {
      value: (_vm.starttime.date),
      callback: function($$v) {
        _vm.$set(_vm.starttime, "date", $$v)
      },
      expression: "starttime.date"
    }
  })], 1)]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                  From this timeslot:\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text"
  }, [_c('el-time-select', {
    attrs: {
      "picker-options": {
        start: '00:00',
        step: '00:15',
        end: '23:45'
      },
      "placeholder": "Click to select a start timeslot"
    },
    model: {
      value: (_vm.starttime.time),
      callback: function($$v) {
        _vm.$set(_vm.starttime, "time", $$v)
      },
      expression: "starttime.time"
    }
  })], 1)]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                  To this day:\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text"
  }, [_c('el-date-picker', {
    attrs: {
      "required": "",
      "type": "date",
      "placeholder": "To this day:"
    },
    model: {
      value: (_vm.endtime.date),
      callback: function($$v) {
        _vm.$set(_vm.endtime, "date", $$v)
      },
      expression: "endtime.date"
    }
  })], 1)]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                  To this timeslot:\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text"
  }, [_c('el-time-select', {
    attrs: {
      "picker-options": {
        start: '00:00',
        step: '00:15',
        end: '23:45'
      },
      "placeholder": "Click to select a start timeslot"
    },
    model: {
      value: (_vm.endtime.time),
      callback: function($$v) {
        _vm.$set(_vm.endtime, "time", $$v)
      },
      expression: "endtime.time"
    }
  })], 1)]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                  Reason:\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blocked.reason),
      expression: "blocked.reason"
    }],
    attrs: {
      "name": "",
      "placeholder": "Add a reason why you block these timeslots",
      "type": "text",
      "value": "I want to take a nap."
    },
    domProps: {
      "value": (_vm.blocked.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.blocked, "reason", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('a', {
    staticClass: "btn btn_green u-fleft u-mr1",
    on: {
      "click": function($event) {
        _vm.updateBlocked()
      }
    }
  }, [_vm._v("\n                  Update\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn_red u-fleft",
    on: {
      "click": function($event) {
        _vm.confirmToggle()
      }
    }
  }, [_vm._v("\n                  Delete\n              ")])])], 1), _vm._v(" "), _c('confirm', {
    attrs: {
      "resource": "blocked timeslot",
      "visible": _vm.alertVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.alertVisible = $event
      }
    }
  }), _vm._v(" "), _c('ok', {
    attrs: {
      "resource": "blocked timeslot",
      "resource-plural": "blocked timeslots",
      "visible": _vm.okVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.okVisible = $event
      }
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "visible": _vm.loadingVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.loadingVisible = $event
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h1', [_vm._v("\n              Edit blocked timeslot\n          ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7daa0a6c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7daa0a6c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Blocked/EditBlocked.vue
// module id = 450
// module chunks = 1